import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { brandsOpenApi, ROUTE_PATHS } from '@constants';
import { FEED_SUPPORTED_PLATFORMS } from '@enums';
import { useNotification } from '@hooks';
import { FEED_GENERIC_ERROR, getFeedErrorMessage } from '@pages/Feed/utils/getFeedErrorMessage';
import { Loader } from '@ui';
import { axiosBoa } from '@utils';
import { StyledWrapper } from '../../Oauth/BigCommerce/Callback';

const ERROR_TITLE = 'Google Merchant Center connection failed';
const ACCESS_DENIED_MESSAGE = 'Google did not grant access to your Merchant Center account. Please try again.';

const GoogleFeedCallback = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const notification = useNotification();

    useEffect(() => {
        // Back to the connection page, with the real reason, so the brand can fix it and retry
        const fail = (description) => {
            notification.error({ message: ERROR_TITLE, description, duration: 10 });
            navigate(ROUTE_PATHS.CAMPAIGNS_CREATE_MANUAL_FEED, { replace: true });
        };

        (async () => {
            const code = searchParams.get('code');
            const state = searchParams.get('state');
            const error = searchParams.get('error');

            if (error) return fail(ACCESS_DENIED_MESSAGE);
            if (!code || !state) return fail(FEED_GENERIC_ERROR);

            try {
                const response = await axiosBoa.get(brandsOpenApi.feedOauth.callback(FEED_SUPPORTED_PLATFORMS.GOOGLE), {
                    params: { code, state }
                });

                if (response.success) {
                    navigate(ROUTE_PATHS.PRODUCTS);
                } else {
                    fail(FEED_GENERIC_ERROR);
                }
            } catch (err) {
                fail(getFeedErrorMessage(err));
            }
        })();
    }, [searchParams, navigate, notification]);

    return (
        <StyledWrapper justify='center' align='center'>
            <Loader size='120px' />
        </StyledWrapper>
    );
};

export default GoogleFeedCallback;
